import { useMemo } from 'react'

import { useFilters } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

const List = () => {
  const filtersPayload = useFilters()

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent pageFilters={pageFilters} />
    </PageContext.Provider>
  )
}

export default List
